<template>
    <div >
      <template v-if="$route.name === 'scoringDetails'">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->         
        <div class="searchCon">
          <div class="searchMain"> 
            <ots-refer
                :selectList="selectList"
                :request-form="requestForm"
                @search="getResult"
            />  
          </div>
        </div>
        <!-- 列表 -->
        <div class="mainCon">
          <!-- 无二级课程情况 -->
          <ots-table-group
            v-if="!hasSubCourse"
            :tableHeader="tableHeader"
            :tableOption="tableOption"
            :tableData="tableData"
            :batchOperBtn="batchOperBtn"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
          <!-- 有二级课程情况 -->
          <el-table
            v-else
            :data="tableData"
            border
            style="width: 100%"
            :height="tableOption.height || 'auto'"
          >
            <el-table-column prop="studentName" label="学生姓名" align="center" :rowspan="2"></el-table-column>
            <el-table-column prop="cardNo" label="证件号" align="center" :rowspan="2"></el-table-column>
            <el-table-column prop="courseName" label="课程名称" align="center" :rowspan="2"></el-table-column>
            <el-table-column prop="oriTotalScore" label="原始总分" align="center" :rowspan="2"></el-table-column>
            <template v-for="(subCourse, index) in subCourseHeaders">
              <el-table-column :label="subCourse" align="center">
                <el-table-column :key="`ori-${index}`" label="原始分" align="center">
                  <template #default="{ row }">
                    {{ getSubCourseValue(row, index, 'oriScore') }}
                  </template>
                </el-table-column>
                <el-table-column :key="`grade-${index}`" label="等级" align="center">
                  <template #default="{ row }">
                    {{ getSubCourseValue(row, index, 'gradeName') }}
                  </template>
                </el-table-column>
                <el-table-column :key="`scored-${index}`" label="赋分" align="center">
                  <template #default="{ row }">
                    {{ getSubCourseValue(row, index, 'scoredScore') }}
                  </template>
                </el-table-column>
              </el-table-column>
            </template>
            <el-table-column prop="scoredTotalScore" label="赋分后总成绩" align="center" :rowspan="2"></el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination-container" v-if="pagination.total > 0">
            <el-pagination
              background
              layout="prev, pager, next, jumper, sizes, total"
              :total="pagination.total"
              :page-size="tableListParams.size"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="tableListParams.page"
              @size-change="changeSize"
              @current-change="changePage"
            />
          </div>
        </div>  
      </template>
      <template v-else>
        <router-view></router-view>
      </template>
    </div>
</template>


<script>
import {   
    getSelectPlanFn,
    getPlanCourseFn,
    scoredRuleResultListFn,
    scoredRuleResultExportFn
} from '@/http/modules/examSet/scoringDetails';


export default {
  name: "scoringDetails",
  data() {
    return {
        
      mainTopBtnList: [  
        {
          title: "导出",
          fn: this.exportExcel
        }
      ],
      tableHeader: [
        {
          title: "学生姓名",
          prop: "studentName",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "课程名称",
          prop: "courseName",
        },
        {
          title: "原始分",
          prop: "oriScore",
        },
        {
          title: "等级",
          prop: "gradeName",
        },
        {
          title: "赋分",
          prop: "scoredScore",
        }, 
      ],
      tableData: [],
      pagination: {
        total: 0
      },
      tableListParams: {
        orders: '',
        page: 1,
        size: 10
      },
      selectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "课程名称",
          type: "select",
          multiple: false,
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        }, 
        {
          title: "关键词",
          type: "input",
          requestKey: "keyWord",
          data: [],
        },  
      ],

      requestForm: {
        planId: null,
        courseId: null,
        keyWord: null,
      },

      tableOption: { border: true }, // 示例配置，根据实际需求调整
      batchOperBtn: [ 
      ], // 如果有批量操作需求，请在此配置按钮
      hasSubCourse: false, // 是否有二级课程
      subCourseHeaders: [] // 二级课程名称列表
    }
  },
  created() { 
    this.initData();
  },
  methods: {
    /*********************************
     * @initData 初始化数据
     ********************************/
    async initData() {
      let { data } = await getSelectPlanFn({ needAudit: 6 });
      this.$set(this.selectList[0], "data", data);
      if (data.length) {
        this.requestForm.planId = data[0].id;
        this.initCourseList(data[0].id);
      };
    },  
    
    /*********************************
     * @initCourseList 课程随着批次变化
     ********************************/
    async initCourseList(val) {
      this.requestForm.courseId = null;
      const { data: courseData } = await getPlanCourseFn({ planId: val });
      this.selectList[1].data = courseData;
      if(courseData.length) {
        this.requestForm.courseId = courseData[0].courseId;
      }      
    },
    
    /*********************************
     * @getResult  获取列表数据
     ********************************/
    async getResult() {
      this.tableListParams = Object.assign(this.tableListParams, this.requestForm);
      const { data } = await scoredRuleResultListFn(this.tableListParams);
      this.tableData = data.records;
      this.pagination.total = data.total;
      
      // 判断是否有二级课程
      if (this.tableData.length > 0) {
        this.hasSubCourse = this.tableData[0].hasSubCourse || false;
        
        // 如果有二级课程，提取二级课程名称
        if (this.hasSubCourse && this.tableData[0].subCourseScores) {
          this.subCourseHeaders = this.tableData[0].subCourseScores.map(item => item.subCourseName);
        } else {
          this.subCourseHeaders = [];
        }
      } else {
        this.hasSubCourse = false;
        this.subCourseHeaders = [];
      }
    },
    
    /*********************************
     * @getSubCourseValue 获取二级课程对应的值
     ********************************/
    getSubCourseValue(row, index, field) {
      if (row.subCourseScores && row.subCourseScores[index]) {
        return row.subCourseScores[index][field] || '';
      }
      return '';
    },

    changeSize(num) {
        this.tableListParams.size=num
        this.getResult()
    },
    changePage(p) {
        this.tableListParams.page=p
        this.getResult()
    },
    
    /*******************************
     * @getResult  导出
     ********************************/
    async exportExcel() {
      let params = {...this.requestForm}
      const { data, code } = await scoredRuleResultExportFn(params);
      if (code) {
        window.open(data);
      }
    },
     
  },

  watch: {
    /******************************
     * @this 批次切换，更新课程
     *****************************/
    "requestForm.planId"(val) {
      this.initCourseList(val);
    }, 
  }
}
</script>


<style  lang="less"  scoped>
.pagination-container {
  margin-top: 10px;
  display:flex; 
  justify-content: center;
  padding: 15px 0px;
  border-radius: 4px;
  .el-pagination {
    display: flex;
    align-items: center;
    
    /deep/.el-pagination__sizes {
      width: 140px;
      margin-right: 15px;
      .el-input {
        width: 140px;
      }
      .el-input__inner {
        width: 140px;
      }
    }
     
    
    /deep/.el-pagination__jump {
      width: 140px;
      margin-left: 15px;

      .el-input__inner {
        width: 90px;
      }

    }
    
    .el-pagination__total {
      margin-right: 15px;
      font-size: 14px;
      color: #606266;
    }
    
    .el-pagination__btn {
      border-radius: 4px;
      transition: all 0.3s;
      
      &:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
    
    .el-pager li {
      border-radius: 4px;
      margin: 0 4px;
      transition: all 0.3s;
      
      &:hover {
        color: #409eff;
      }
      
      &.active {
        background-color: #409eff;
        color: #fff;
        border-color: #409eff;
      }
    }
  
  }
}
</style>

